import { createContext } from 'react';
import type { Theme } from './theme';

export type ThemeContextValue = {
  theme: Theme;
  setTheme: (theme: Theme) => void;
  toggleTheme: () => void;
};

/**
 * Lives outside the provider component so the provider file exports only a
 * component — which is what keeps React Fast Refresh working.
 */
export const ThemeContext = createContext<ThemeContextValue | null>(null);
